import {
    getNumberAsLocaleNumber as getSharedNumberAsLocaleNumber,
    truncate,
} from '@Sage/ssm-utils';

let USERLOCALE = 'en-US';

export const setupUserLocaleNumber = (locale) => {
    if (locale === 'es') locale = 'es-ES';
    if (locale === 'en') locale = 'en-US';
    if (locale === 'en-US') return; // default locale for the library
    locale = locale.split('-');
    if (locale.length > 1) {
        locale[1] = locale[1].toUpperCase();
        locale = locale.join('-');
    }
    USERLOCALE = locale;
};

export { truncate };

export const getNumberAsLocaleNumber = (value, options = {}, useAllDecimals = false) => {
    return getSharedNumberAsLocaleNumber(value, options, useAllDecimals, USERLOCALE);
};

export const randomId = () => {
    return Math.floor(Math.random() * 10000);
};

export const nFormatter = (num, digits) => {
    const lookup = [
        { value: 1e18, symbol: 'E' },
        { value: 1e15, symbol: 'P' },
        { value: 1e12, symbol: 'T' },
        { value: 1e9, symbol: 'G' },
        { value: 1e6, symbol: 'M' },
        { value: 1e3, symbol: 'k' },
        { value: 1, symbol: '' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let item = lookup.find((item) => num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
};
